export default class PricingCalculator {
    static getPlanPriceViaOverrides(planName, overrides = [], discount = 0, period = 'monthly') {
        const prices = window.prices;
        const basePrice = prices['base'][period][planName.toLowerCase()];
        const panelPlanName = (period === 'yearly' ? 'ANNUAL_' : '') + planName.toUpperCase();

        overrides = this.addDefaultOverrides(overrides, discount);

        for (let val in overrides) {
            if (overrides[val].plan === panelPlanName) {
                if (period === 'monthly') {
                    return Math.floor(basePrice * (100 - overrides[val].value) / 100);
                } else {
                    const yearlyBasePrice = basePrice * 12;
                    return Math.ceil(Math.floor(yearlyBasePrice - (overrides[val].value/100) * yearlyBasePrice) / 12);
                }
            }
        }

        return basePrice;
    }

    static getUpfrontPriceViaOverrides(planName, overrides = [], discount = 0) {
        const prices = window.prices;
        const baseYearlyUpfrontPrice = prices['base']['yearly'][planName.toLowerCase()] * 12;
        const panelPlanName = 'ANNUAL_' + planName.toUpperCase();

        for (let val in overrides) {
            if (overrides[val].plan === panelPlanName) {
                return Math.floor(baseYearlyUpfrontPrice * (100 - overrides[val].value) / 100);
            }
        }

        return baseYearlyUpfrontPrice;
    }

    static addDefaultOverrides(overrides, discount) {
        const plans = ["PROFIT_Q324", "SCALE_Q324", "START_UP_Q323", "AGENCY_Q123", "ENTERPRISE_Q123"];
        const periods = ['', 'ANNUAL_', 'ANNUAL2_', 'ANNUAL3_', 'ANNUAL4_'];

        if (discount < 0 || discount >= 100) return overrides;

        for (let i in plans) {
            for (let j in periods ) {
                overrides.push({plan: periods[j] + plans[i], value: discount});
            }
        }

        return overrides;
    }
}